<div #content>
    <div *ngIf="entity" class="item p-y-4" [ngClass]="{'item--pointer':this.href || displayViewButton}"  >

        <div class="d-flex gap-4">
            <div class="flex-grow-1 flex-shrink-1">
                <ng-content></ng-content>
            </div>
            <div class="flex-grow-0 flex-shrink-0 gap-4 d-flex justify-content-end flex-wrap">
                <app-loading [loading]="deleteLoading" [showText]="false" slot="end"></app-loading>
                <ng-container *ngIf="!deleteLoading">
                    <ng-container *ngIf="!displayButtonsInMore">
                        <ng-content select="[buttons]"></ng-content>
                        <app-button (click)="clicked()"
                                    *ngIf="(href || displayViewButton) && !viewButtonInMore"
                                    [withMargin]="true"
                                    [withPadding]="false"
                                    iconName="search"
                                    tooltip="Voir"
                                    slot="end"></app-button>
                    </ng-container>

                    <ng-container *ngIf="editButtonInMore || (deleteButtonInMore && deleteService) || (moreButtonsContents?.length > 0) || ((href || displayViewButton) && viewButtonInMore) else notMoreButtons">
                        <app-button iconName="dots-circle-horizontal" *ngIf="!displayButtonsInMore" (clickEvent)="displayButtonsInMore = true"></app-button>
                        <ng-container *ngIf="displayButtonsInMore">
                            <ng-content select="[more-buttons]"></ng-content>
                            <app-button (click)="clicked()"
                                        *ngIf="(href || displayViewButton) && viewButtonInMore"
                                        [withMargin]="true"
                                        [withPadding]="false"
                                        iconName="search"
                                        tooltip="Voir"
                                        slot="end"></app-button>
                            <app-button (click)="onUpdate()"
                                        *ngIf="displayUpdateButton" [withMargin]="true" [withPadding]="false"
                                        tooltip="Modifier"
                                        size="small"
                                        iconName="pencil" slot="end"></app-button>
                            <app-confirmation-button (confirm)="onDeletionConfirmed()" *ngIf="displayDeleteButton && ! deleteLoading"
                                                     [options]="confirmationButtonOption" [withMargin]="true" [withPadding]="false"
                                                     tooltip="Supprimer"
                                                     iconName="trash"
                                                     [loading]="deleteLoading"></app-confirmation-button>
                            <app-button iconName="arrow-back" *ngIf="displayButtonsInMore" (clickEvent)="displayButtonsInMore = false"></app-button>
                        </ng-container>
                    </ng-container>

                    <ng-template #notMoreButtons>
                        <ng-container *ngIf="!displayButtonsInMore">
                            <app-button (click)="onUpdate()"
                                        *ngIf="displayUpdateButton" [withMargin]="true" [withPadding]="false"
                                        tooltip="Modifier"
                                        iconName="pencil" slot="end"></app-button>
                            <app-confirmation-button (confirm)="onDeletionConfirmed()" *ngIf="displayDeleteButton && ! deleteLoading"
                                                     [options]="confirmationButtonOption" [withMargin]="true" [withPadding]="false"
                                                     tooltip="Supprimer"
                                                     iconName="trash"
                                                     [loading]="deleteLoading"></app-confirmation-button>
                        </ng-container>
                    </ng-template>
                </ng-container>
            </div>
        </div>
        <div>
            <ng-content select="[bottom]"></ng-content>
        </div>

        <ion-note *ngIf="displayMetadata" style="font-size: 0.7em;">
            <ion-icon name="person-outline"></ion-icon>
            {{metadataUpdaterName }}
            {{metadataDate | date:"dd/MM/y" }}
        </ion-note>

        <div style="clear: both"></div>
    </div>
</div>
